import React from 'react';

const CustomContent = ({
  text,
  textColor = "#333333", 
  textSize = "20px", // default size
  margin = "m-0", 
  padding = "p-0", 
  fontStyle = "font-Lato", 
  textAlign = "left",
  marginTop = "0px",
  width="100%",
  leading = "32px",
  textStyle,
  fontWeight,
  tracking = "tight"
}) => {
  return (
    <div
      style={{
        textAlign: textAlign,
        marginTop: marginTop,
        padding: padding,
        fontWeight: fontWeight,
        fontStyle: textStyle,
        color: textColor,
        fontSize: window.innerWidth < 450 ? "16px" : textSize,
        lineHeight: window.innerWidth < 450 ? "24px" : leading,
        width: window.innerWidth < 950 ? "100%" : width,
        minHeight: window.innerWidth < 450 ? "24px" : leading,
      }}
      className={`${tracking} relative ${margin} ${padding} ${fontStyle} transition-all duration-300`}
      dangerouslySetInnerHTML={{ __html: text }}
    ></div>
  );
};

export default CustomContent;
